module.exports = __webpack_public_path__ + "img/14.df784ed6.png";